import React from "react";

function ScreenNoConectionError({ isError = false }) {
  if (isError) {
    return (
      <div style={modalStyle}>
        <div style={spinnerStyle}></div>
        <p>Problemas de conexão</p>
        <p>Por favor verifica a tua conexão e volta a tentar.</p>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }
}

const modalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.85)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  color: "#fff",
  zIndex: 9999,
};

const spinnerStyle = {
  width: "60px",
  height: "60px",
  border: "8px solid #f3f3f3",
  borderTop: "8px solid #EE754C",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
  marginBottom: "15px",
};

export default ScreenNoConectionError;
